<template>
    <div class="container">
        <div class="content">
            <div v-html="footerHtmlText"></div>
        </div>
    </div>
</template>

<script setup lang="ts">
import { computed, defineProps } from 'vue';

function resolveText(text: string | Record<string, string>): string {
  if (typeof text === 'string') return text
  const lang = localStorage.getItem('lang') || 'en'
  return text[lang] || text['en'] || ''
}

const props = defineProps<{
    itemData: {
        htmlText: string | Record<string, string>
    }
}>()
const footerHtmlText = computed(() => resolveText(props.itemData.htmlText))
</script>
<style scoped>
.container {
    padding: 10px 15px 50px;
    line-height: 20px;
    font-size: 11px;
}


.ql-align-center {
    text-align: center !important;
}

.ql-align-center span {
    display: inline-block;
    width: 100%;
}


.ql-align-right {
    text-align: right !important;
}

.ql-align-right span {
    display: inline-block;
    width: 100%;
}

.ql-align-left {
    text-align: left !important;
}

.ql-align-left span {
    display: inline-block;
    width: 100%;
}
</style>